import common from './common';
import login from './login';
import register from './register';
import frame from './frame';
import features from './features';
import forgot from './forgot';
import reset from './reset';
import auth from './auth';
import warning from './warning';
import changePassword from './changePassword';
import admin from './admin';

export default {
  'zh-Hant': {
    common,
    login,
    register,
    frame,
    features,
    forgot,
    reset,
    auth,
    admin,
    warning,
    changePassword
  }
};
